import TabNavigation from "@/components/ui/TabNavigation";
import { useUser } from "@/context/user-context";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { TabItem } from "../ui/TabNavigation/types";
import { AbReleases, Agent, Prompt } from "../ui/icons";

export default function RegistryTabs() {
  const userContext = useUser();
  const location = useLocation();

  const activeWorkspaceId = userContext?.activeWorkspaceId;

  const tabs: TabItem[] = useMemo(
    () => [
      {
        id: 0,
        name: "Prompts",
        outlineIcon: <Prompt className="h-4 w-4" />,
        solidIcon: <Prompt className="h-4 w-4" />,
        content: null,
        path: `/workspace/${activeWorkspaceId}/prompt`,
        align: "left",
      },
      {
        id: 1,
        name: "A/B Releases",
        outlineIcon: <AbReleases className="h-4 w-4" />,
        solidIcon: <AbReleases className="h-4 w-4" />,
        content: null,
        path: `/workspace/${activeWorkspaceId}/ab-releases`,
        align: "left",
      },
      {
        id: 2,
        name: "Agents",
        outlineIcon: <Agent className="h-4 w-4" />,
        solidIcon: <Agent className="h-4 w-4" />,
        content: null,
        path: `/workspace/${activeWorkspaceId}/workflow`,
        align: "left",
      },
    ],
    [activeWorkspaceId],
  );

  const getCurrentTabIndex = () => {
    const path = location.pathname;

    if (path.includes("/prompt") || path.includes("/prompt-folder")) {
      return 0;
    } else if (path.includes("/ab-releases")) {
      return 1;
    } else if (path.includes("/workflow")) {
      return 2;
    }

    return 0; // Default to "Prompts" tab
  };

  return (
    <div className="mt-4">
      <TabNavigation currentTabIndex={getCurrentTabIndex()} tabs={tabs} />
    </div>
  );
}
